import {CreatePersonalSubject} from './variants/create-personal-subject';
import {EditPersonalSubject} from './variants/edit-personal-subject';

export const PersonalSubjectDialog = {
	CreatePersonalSubject,
	EditPersonalSubject,
};

export * from './variants/create-personal-subject/events';
export * from './variants/edit-personal-subject/events';
